import React from "react";
import { GridContainer, TextContainer } from "../../Style/SellingCss";

const SellingContainer = ({
  imageContent,
  reverseOrder,
  paragraph,
  styledBackground,
  styledText,
}) => {
  return (
    <GridContainer reverse={reverseOrder} styledBackground={styledBackground}>
      <TextContainer styledText={styledText}>
        <div>{paragraph}</div>
      </TextContainer>
      {imageContent}
    </GridContainer>
  );
};

export default SellingContainer;
